import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Header from 'library/components/header';
import Search from 'library/components/search';
import Navigation from 'library/components/navigation';
import Overlay from 'library/components/overlay';
import {
  getContentOverlayDisplayState,
} from 'store/shared/selectors';
import ROUTES from '../../constants/routes';
import { MainSection } from './styles';

const withNavigationFilters = (WrappedComponent) => (
  function WithModalContainer({
    onSuggestionSelect,
    suggestions,
    onSuggestionsReset,
    searchPlaceholder,
    searchTypes = [],
    isSuggestionLoading,
    queryParameter = null,
    ...props
  }) {
    const { pathname } = useLocation();
    const showActions = pathname !== ROUTES.SETTINGS && !pathname.includes('/set-details') && !pathname.includes('/project-details');
    const showSearchByColor = !pathname.includes(ROUTES.WISHLIST);
    const showBrowseMode = !pathname.includes('/project-details') && showActions;
    const isContentOverlayDisplayed = useSelector(getContentOverlayDisplayState);

    return (
      <>
        <Header
          showActions={showActions}
          showBrowseMode={showBrowseMode}
        >
          <Search
            onSelect={onSuggestionSelect}
            queryParameter={queryParameter}
            onReset={onSuggestionsReset}
            options={suggestions}
            loading={isSuggestionLoading}
            placeholder={searchPlaceholder}
            types={searchTypes}
            showSearchByColor={showSearchByColor}
          />
        </Header>
        <div className="main__wrapper">
          {isContentOverlayDisplayed && <Overlay />}
          <Navigation />
          <MainSection>
            <WrappedComponent {...props} />
          </MainSection>
        </div>
      </>
    );
  }
);

export default withNavigationFilters;
